import React, {useContext} from 'react';

const LinkingContext = React.createContext();

export const useLinkingContext = () => useContext(LinkingContext);
export default LinkingContext;
